import { memo } from 'react';
import styles from './ErrorMessage.module.scss';

export type Props = {
  errors: string | undefined;
  className?: string;
  dataTest?: string;
};

export default memo(function ErrorMessage({
  errors,
  className,
  dataTest = 'errorMessage',
}: Props) {
  const list = errors?.split('-divider-');
  return (
    <div className={className} data-test={dataTest} data-testid={dataTest}>
      {list ? (
        <ul className={styles['error-list']}>
          {list.map(
            (item, i) =>
              item && (
                <li
                  key={i}
                  data-test={`${dataTest}-item-${i}-row`}
                  data-testid={`${dataTest}-item-${i}-row`}
                >
                  {item}
                </li>
              ),
          )}
        </ul>
      ) : (
        <div>{errors}</div>
      )}
    </div>
  );
});
